import WincareOldAdminList from "./pages/WincareOldAdminList.vue";
import WincareOldAdminEventiList from "./pages/WincareOldAdminEventiList.vue";

export default {
    WincareOldAdminList,
    WincareOldAdminEventiList,
};
